import React, { useState } from "react";
import YoutubeTutorial from "Components/common/YoutubeTutorial";
import ConfigureButton from "../ConfigureButton";
import InstallButton from "../InstallButton";

const SlackAction = props => {
  const {
    slackConnected = "",
    data: { youtubeLink = "" },
    toolTipPopup,
    slackConfigureCbk = () => {},
    isFeatureEnabled = false
  } = props;
  const [showVideo, setVideo] = useState(false);

  const closeVideo = () => {
    setVideo(false);
  };

  return !isFeatureEnabled ? (
    <InstallButton {...props} />
  ) : slackConnected ? (
    <div className="buttonCont wrapConnectedBtn">
      <div
        className={`connectedBtnCont btn ${isFeatureEnabled ? "" : "disabled"}`}
        onClick={slackConfigureCbk}
      >
        <i className="material-icons-outlined">settings</i>
        Configure
      </div>
      {showVideo && (
        <YoutubeTutorial videoId={youtubeLink} closeCbk={closeVideo} />
      )}
    </div>
  ) : (
    <div className="buttonCont">
      <ConfigureButton
        toolTipPopup={toolTipPopup}
        value={"Configure"}
        configureCbk={slackConfigureCbk}
        isFeatureEnabled={isFeatureEnabled}
      />
    </div>
  );
};

export default SlackAction;
export { SlackAction };
